<template>
  <div class="relative">
    <slot name="content" />
    <div
      id="infiniteBottom"
      ref="bottom"
    />
    <slot name="loading" />
    <LazyScrollToButton
      v-if="scrollToButton"
      offset-type="viewport"
      :selector="scrollBackElement"
      :offset-to-element="offsetToElement"
    >
      <template
        v-if="$slots.scrollBackLabel"
        #label
      >
        <slot name="scrollBackLabel" />
      </template>
    </LazyScrollToButton>
  </div>
</template>

<script>
import throttle from 'lodash.throttle'

export default defineNuxtComponent({
  props: {
    scrollingOffset: { // px
      type: Number,
      default: 150,
    },

    interval: { // ms
      type: Number,
      default: 500,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    scrollBackElement: {
      type: String,
      default: undefined,
    },

    offsetToElement: {
      type: Boolean,
      default: false,
    },

    scrollToButton: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['fetch'],

  watch: {
    disabled () {
      this.scrollThrottle?.cancel()
    },
  },

  mounted () {
    this.scrollThrottle = throttle(() => {
      if (!this.disabled) {
        this.$emit('fetch')
      }
    }, 300)

    this.init()

    window.addEventListener('scroll', this.onScrollListener)
  },

  beforeUnmount () {
    window.removeEventListener('scroll', this.onScrollListener)
    this.scrollThrottle?.cancel()
  },

  methods: {
    init () {
      const { top, innerHeight, offset } = this.getScrollCoordinates()

      if (top < innerHeight + offset) {
        this.scrollThrottle()
      }
    },

    getScrollCoordinates () {
      return {
        top: this.$refs.bottom.getBoundingClientRect()?.top || 0,
        innerHeight: window?.innerHeight,
        offset: this.scrollingOffset,
      }
    },

    onScrollListener () {
      if (!this.$refs.bottom || !import.meta.browser) {
        return
      }
      const { top, innerHeight, offset } = this.getScrollCoordinates()

      if (top < innerHeight + offset) {
        this.scrollThrottle()
      }
    },
  },
})
</script>
